import React from 'react';
import { Users } from 'lucide-react';
import { TYPE } from '../../constants/typeScale';

/**
 * WHAT THE CREW PANE SAYS BEFORE THERE IS A CREW.
 *
 * The right pane used to open on a LIST of every chat the creator had, with a "New crew" button on top. Owner
 * 2026-08-23: *"remove New crew and the group list for now — simply switch group in chat mode based on where
 * the user navigated to on the left pane, and the members of the right pane group update based on the staff,
 * cast, writer, director etc. making the currently focused project."*
 *
 * That collapses the pane from two levels to one. It is not a place you navigate; it is the crew of the thing
 * you have open, and it follows the left pane. So the only state left to design is the one before anybody has
 * been hired — which is a teaching moment, not an empty list: it says where crew comes from.
 */
const CrewPaneEmpty: React.FC<{ productionOpen: boolean }> = ({ productionOpen }) => (
  <div className="flex flex-1 flex-col items-center justify-center gap-2 p-6 text-center">
    <Users className="h-5 w-5 text-secondary-300 dark:text-secondary-600" aria-hidden />
    <p className={`max-w-[15rem] ${TYPE.body} leading-relaxed text-secondary-500 dark:text-secondary-400`}>
      {productionOpen
        ? 'Nobody is on this episode yet. Recruit a writer on Story or a lead on the Series page, and your conversation with them opens here.'
        : 'Open an episode on the left and the crew making it will be here, ready to talk.'}
    </p>
  </div>
);

export default CrewPaneEmpty;
